export function userListContainsAIAssistant(userList: { id: string }[] | null): boolean {
  return !!(userList && userList.find(user => user?.id === process.env.NEXT_PUBLIC_COLEAP_BOT_USER_ID))
}
